import React, {useEffect} from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./pages/Home";
import Header from './components/Header'
import Login from './components/Login'
import Checkout from './components/Checkout'
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import Payment from './components/Payment'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import Orders from './components/Orders';

const promise = loadStripe('pk_test_51IuQ69FL4U1pIS6GVMn19XQqHm8e6EQobU3u8I7iQflfo3QBkXTbSADqVpWrrc9TTVeoGH6h1274Hk7a1m5GggQ900dSvHZHd9')

function App() {

  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    // will only run once when the app component loads...

    auth.onAuthStateChanged((authUser) => {
      console.log("THE USER IS >>> ", authUser);

      if (authUser) {
        // the user just logged in / the user was logged in

        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        // the user is logged out
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);

  return (
    <Router>
    <div className="App">
      {/* Header */}
      <Header/>
      {/* Home */}
      
      <Switch>
        
        <Route path="/orders">
          <Orders />
        </Route>

        <Route path="/checkout">
          <Checkout />
        </Route>

        <Route path="/login">
          <Login />
        </Route>

        <Route path="/payment">
          <Elements stripe={promise}> 
            <Payment />
          </Elements>
        </Route>

        <Route path="/">
          <Home />
        </Route>

      </Switch>
    </div>
    </Router>
  );
}

export default App;
